import { render, staticRenderFns } from "./TransitionSentenceSequence.vue?vue&type=template&id=0cf20926&scoped=true&"
import script from "./TransitionSentenceSequence.vue?vue&type=script&lang=js&"
export * from "./TransitionSentenceSequence.vue?vue&type=script&lang=js&"
import style0 from "./TransitionSentenceSequence.vue?vue&type=style&index=0&id=0cf20926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf20926",
  null
  
)

export default component.exports